import React from 'react';
import classNames from 'classnames';
import styles from './SubHeading.module.scss';

export default function SubHeading({ children, className }) {
  return <p className={classNames(styles.subheading, className)}>{children}</p>;
}
